import React, { FC } from 'react';
import {
  TestimonialCardContainer,
  TestimonialHeader,
  TestimonialImage,
  TestimonialDetails,
  TestimonialTip,
  TestimonialName,
} from './TestimonialCard.styles';
import { TestimonialCardProps } from './TestimonialCard.types';
import { Body, Label } from '../TypographyNew';

export const TestimonialCard: FC<TestimonialCardProps> = ({
  name,
  image,
  role,
  message,
}) => {
  return (
    <>
      <TestimonialCardContainer>
        <TestimonialHeader>
          <TestimonialImage
            alt={`testimonial picture of ${name} ${role}`}
            src={image}
          />
          <TestimonialDetails>
            <TestimonialName variant={1}>{name}</TestimonialName>
            <Label variant={1}>{role}</Label>
          </TestimonialDetails>
        </TestimonialHeader>
        <Body variant={2}>{message}</Body>
        <TestimonialTip />
      </TestimonialCardContainer>
    </>
  );
};
